// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-mismatch-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 16px;
}

.email-mismatch-dialog {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: fadeInModal 0.2s ease-out;
}

@keyframes fadeInModal {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.email-mismatch-header {
  padding: 18px 24px 12px 24px;
  border-bottom: 1px solid #eaeaea;
}

.email-mismatch-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.email-mismatch-body {
  padding: 20px 24px;
  font-size: 14px;
  color: #4a4a4a;
  line-height: 1.5;
}

.email-mismatch-text {
  margin: 0 0 8px 0;
  word-break: break-word;
}

.email-mismatch-subtext {
  margin: 14px 0 0 0;
  color: #666666;
  font-style: italic;
}

.email-mismatch-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 24px;
  background-color: #f8f9fa;
  border-top: 1px solid #eaeaea;
}

.email-mismatch-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  transition: background-color 0.15s ease;
}

.email-mismatch-btn-cancel {
  background-color: #e4e6eb;
  color: #4b4f56;
}

.email-mismatch-btn-cancel:hover {
  background-color: #d8dadf;
}

.email-mismatch-btn-signout {
  background-color: #007bff;
  color: #ffffff;
}

.email-mismatch-btn-signout:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/components/EmailMismatchModal/EmailMismatchModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".email-mismatch-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 99999;\r\n  padding: 16px;\r\n}\r\n\r\n.email-mismatch-dialog {\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  width: 100%;\r\n  max-width: 440px;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;\r\n  animation: fadeInModal 0.2s ease-out;\r\n}\r\n\r\n@keyframes fadeInModal {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.email-mismatch-header {\r\n  padding: 18px 24px 12px 24px;\r\n  border-bottom: 1px solid #eaeaea;\r\n}\r\n\r\n.email-mismatch-title {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n}\r\n\r\n.email-mismatch-body {\r\n  padding: 20px 24px;\r\n  font-size: 14px;\r\n  color: #4a4a4a;\r\n  line-height: 1.5;\r\n}\r\n\r\n.email-mismatch-text {\r\n  margin: 0 0 8px 0;\r\n  word-break: break-word;\r\n}\r\n\r\n.email-mismatch-subtext {\r\n  margin: 14px 0 0 0;\r\n  color: #666666;\r\n  font-style: italic;\r\n}\r\n\r\n.email-mismatch-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  padding: 14px 24px;\r\n  background-color: #f8f9fa;\r\n  border-top: 1px solid #eaeaea;\r\n}\r\n\r\n.email-mismatch-btn {\r\n  padding: 8px 18px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.email-mismatch-btn-cancel {\r\n  background-color: #e4e6eb;\r\n  color: #4b4f56;\r\n}\r\n\r\n.email-mismatch-btn-cancel:hover {\r\n  background-color: #d8dadf;\r\n}\r\n\r\n.email-mismatch-btn-signout {\r\n  background-color: #007bff;\r\n  color: #ffffff;\r\n}\r\n\r\n.email-mismatch-btn-signout:hover {\r\n  background-color: #0056b3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
